/* eslint-disable react/jsx-no-bind */
import { Paper, Typography, Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import api, { authHeader } from '../../../../../../services/API/apiConfig';
import { TablePayables } from '../../../../../components/singleComponents/tables/TablePayables';

import {
  BtnSecondaryStyled,
  BtnStyled,
  RootStyled,
} from './ConstructionPayable.styles';
import { BudgetInfo } from '../budgets/BudgetInfo';

const headings = [
  'Vencimento',
  'Fornecedor',
  'Descrição',
  'Item',
  'Valor',
  'Status',
  'Lançamento',
  'Anexos',
  'Duplicar',
];

export function ConstructionPayable() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [constructionName, setConstructionName] = useState('');
  const [finished, setFinished] = useState(true);
  const [exportKey, setExportKey] = useState(null);
  const [headerInfo, setHeaderInfo] = useState({});
  const [filter, setFilter] = useState(null);
  const [payables, setPayables] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [hasBudget, setHasBudget] = useState(false);

  const handleGoToEditPayable = useCallback((payableID) => {
    navigate(`/new-release/${payableID}`, {
      state: { from: location.pathname },
    });
  }, []);

  function handleGoToNewPayable() {
    localStorage.setItem('constructionId', id);
    navigate('/new-release', { state: { from: location.pathname } });
  }

  useEffect(() => {
    async function getBudget() {
      await api
        .get(`/constructions/${id}/details?budget=false`, {
          headers: authHeader(),
        })
        .then((res) => setHeaderInfo(res.data.data));
    }

    async function getBudgetInfo() {
      await api
        .get(`/constructions/${id}/budgets?array=false`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          if (data.items !== undefined && data.items.length) {
            setHasBudget(true);
          }
        });
    }

    getBudget();
    getBudgetInfo();
  }, [id]);

  useEffect(() => {
    api
      .get(`/constructions/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFinished(data?.finished);
        setConstructionName(data?.name);
        setExportKey(data?.export_key);
      });
  }, []);

  function exportPayable() {
    const payablesIds = filterData
      .map(({ id: payableId }) => payableId)
      .join(',');

    api
      .get(
        `/constructions/${id}/payable_xlsx?export_key=${exportKey}&payables_ids=${payablesIds}`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const { baseURL, url } = res.config;
        window.open(baseURL + url);
      });
  }

  const getPayables = () => {
    if (id) {
      api
        .get(`/constructions/${id}/payables`, {
          headers: authHeader(),
        })
        .then((response) => {
          const { data } = response.data;
          setPayables(data);
        });
    } else {
      api.get('/payables', { headers: authHeader() }).then((response) => {
        const { data } = response.data;
        setPayables(data);
      });
    }
  };

  useEffect(() => {
    getPayables();
  }, []);

  return (
    <Paper>
      <RootStyled>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            id="construction-name"
            style={{ fontSize: '24px' }}
            variant="h1"
          >
            {constructionName}
          </Typography>
          <Box sx={{ marginTop: '16px' }}>
            <BtnStyled
              id="export-button"
              variant="outlined"
              disabled={!payables.length}
              onClick={exportPayable}
              sx={{ marginRight: '16px' }}
            >
              Exportar lançamento
            </BtnStyled>
            {!finished && (
              <BtnSecondaryStyled
                id="new-payable-button"
                variant="contained"
                onClick={() => handleGoToNewPayable()}
                startIcon={<MdAdd />}
              >
                Novo lançamento
              </BtnSecondaryStyled>
            )}
          </Box>
        </Box>
        {hasBudget && (
          <Box sx={{ marginTop: '16px' }} id="budget-box">
            <BudgetInfo info={headerInfo} />
          </Box>
        )}
        <TablePayables
          filter={filter}
          setFilter={setFilter}
          constructionId={id}
          headings={headings}
          callbackClickRow={handleGoToEditPayable}
          isConstruction
          filterData={filterData}
          setFilterData={setFilterData}
        />
      </RootStyled>
    </Paper>
  );
}
